import React, { useEffect, useState } from "react";
import Button from "../../Common/FormElements/Button/Button";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { t } from "i18next";
import { toast } from "react-toastify";
import { getErrorPayMessage } from "../../../Utils";
import LoadingView from "../../../Utils/ViewWrapper/LoadingView/LoadingView";
import { fetchCommande } from "../../../REDUX/actions/commandes";

const PayementSuccess = () => {
  const { commande } = useSelector((state) => state.commandeReducer);
  const { isAlreadyDone } = useSelector((state) => state.paymentReducer);

  const [paymentStatus, setPaymentStatus] = useState(true);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [searchParams] = useSearchParams();
  const commandeId = +searchParams?.get("Ref")?.split("/")[0];
  const commandeNb = searchParams?.get("Ref")?.split("/")[1];
  const totalAmount = searchParams?.get("Mt");

  useEffect(() => {
    isAlreadyDone && navigate("/catalogue");
  }, [isAlreadyDone]);

  useEffect(() => {
    const url = new URL(window.location.href);

    if (!url.href.includes("succes")) {
      const urlParams = new URLSearchParams(window.location.search);
      const specificParam = urlParams.get("Erreur");
      if (specificParam) {
        toast.error(getErrorPayMessage(specificParam));
      }
    }
  }, []);

  useEffect(() => {
    dispatch(fetchCommande(commandeId));
  }, [commandeId, dispatch]);

  useEffect(() => {
    const interval = setInterval(() => {
      dispatch(fetchCommande(commandeId));
      setPaymentStatus(commande?.processing_payment);
    }, 3000);

    return () => clearInterval(interval);
  }, [commandeId, dispatch, commande?.processing_payment]);

  return (
    <div className="d-flex flex-column align-items-center justify-content-center">
      <img
        src="payement-success.png"
        className="w25 mb-4"
        alt="Succés payement"
      />
      {paymentStatus ? (
        // {factureLoading || cartLoading || paymentLoading ? (
        <div className="w-50">
          <h2 className="text-center mb-3">
            {t(
              "Your payment is being processed. This may take a few minutes. Please wait a moment ..."
            )}
          </h2>
          <LoadingView />
        </div>
      ) : (
        <>
          <h2>{t("Payment successfully completed !")}</h2>
          <div className="mt-5 d-flex flex-column gap-2">
            <span>
              {t("Order number")} : <span className="bold">{commandeNb}</span>
            </span>
            <span>
              {t("Total amount paid")} :{" "}
              <span className="bold">{totalAmount / 100} €</span>
            </span>
          </div>
          <Button
            className="mt-5"
            onClick={() => navigate("/commandes")}
            loading={paymentStatus}
            disabled={paymentStatus}
            // loading={factureLoading || cartLoading}
            // disabled={factureLoading || cartLoading}
          >
            {t("Orders")}
          </Button>
        </>
      )}
    </div>
  );
};

export default PayementSuccess;
